import 'react-phone-input-2/lib/style.css';

import { Link, Text, VStack, Checkbox, Flex } from '@chakra-ui/react';
import { useState, useEffect } from 'react';

import PhoneInput from 'react-phone-input-2';
import { Link as ReactLink } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import { useUIStore } from '#store';

/** Component which renders the page where we get the phone number */
export function PhoneNumber() {
  const { contactId, setContactIdInput, registerContact, setToast } =
    useUIStore(
      (state) => ({
        contactId: state.contactInput.contactId,
        setContactIdInput: state.setContactIdInput,
        registerContact: state.registerContact,
        setToast: state.setToast,
      }),
      shallow
    );
  const [enableSubmit, setEnableSubmit] = useState(false);
  
  // Check if it's a US/CA number (country code +1)
  const isUSorCA = contactId?.startsWith('1');
  
  const checkValidity = async (inputNumber) => {
    setContactIdInput(inputNumber);
    const { isValidPhoneNumber } = await import('libphonenumber-js');
    setEnableSubmit(isValidPhoneNumber(`+${inputNumber}`));
  };

  useEffect(() => {
    checkValidity(contactId);
  }, []);

  const handlePhoneSumbit = () => {
    if (!enableSubmit) {
      return;
    }
    registerContact();
  };

  return (
    <VStack spacing={6}>
      {/* <Suspense fallback={<Skeleton w="300px" h="2.5em" />}> */}
      <Text color={'white'} fontSize={['lg']} mb={-2}>
        Enter Phone Number
      </Text>
      <PhoneInput
        country={'us'}
        placeholder="Enter phone number"
        value={contactId}
        onChange={checkValidity}
        countryCodeEditable={false}
        buttonStyle={{
          paddingLeft: 5,
          paddingRight: 5,
        }}
        inputStyle={{
          paddingTop: 20,
          paddingBottom: 20,
          paddingLeft: 54,
          fontSize: '1.1em',
        }}
        containerStyle={{
          width: 'auto',
        }}
      />
      <Flex alignItems={'baseline'} maxW={'300px'}>
        <Checkbox
          colorScheme="white"
          color={'white'}
          isChecked
          onChange={() => {
            setToast({
              title: "Can't proceed without concent",
              description: 'We require your consent to send you messages',
              status: 'error',
              duration: 2000,
              isClosable: true,
              position: 'top',
            });
          }}
        ></Checkbox>
        <Text fontSize={'0.9em'} color={'white'} ml={2}>
          You agree to receive OTPs and availability notifications via {isUSorCA ? 'text' : 'WhatsApp'}.
        </Text>
      </Flex>
      {/* </Suspense> */}
      <Link
        as={ReactLink}
        color="black"
        bg="white"
        px={4}
        py={2}
        rounded="md"
        fontWeight={500}
        _hover={{ opacity: enableSubmit ? 0.8 : 0.7 }}
        opacity={enableSubmit ? 1 : 0.7}
        onClick={handlePhoneSumbit}
        to=""
      >
        {isUSorCA ? 'Send OTP' : 'Send OTP via WhatsApp'}
      </Link>
    </VStack>
  );
}
